module.exports = __webpack_public_path__ + "img/no-data.a7679842.png";